module.exports = __webpack_public_path__ + "img/qiling.96884cc4.webp";